<template>
    <div class="newsList-wrapper">
        <div class="pc-newsList" v-if="!isPhone" :class="columnId && `pc-newsList-${$Common.Base64.decode(columnId)}`">
            <div class="news-item pointer" :class="{'subject-item': isSubjectList || isActivity, 'isSpecial': isSpecial}" v-for="(item ,i) in list" :key="i" @click="toDetail(item)">
                <div class="img bgc-default">
                    <img :src="item.img169 || item.imgUrl || item.topImgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt="">
                    <span v-show="item.newsKind == 4" class="video-icon"></span>
                    <span v-show="item.newsKind == 4" class="video-duration">{{item.videoTime | videoDuration}}</span>
                    <span v-show="item.isSubjectEntrance || item.extKind == 2" class="label" :class="{'label-activity': !item.isSubjectEntrance && item.extKind == 2, 'isSpecial': isSpecial}">{{item | newsKind}}</span>
                    <span v-show="isSubjectList" class="label" :class="{'isSpecial': isSpecial}">{{item | newsKind}}>专题</span>
                </div>
                <div class="text" v-if="isSubjectList || isActivity">
                    <div class="title line-2">
                        {{item.name}}
                    </div>
                </div>
                <div class="text" v-else>
                    <div class="title line-2">
                        {{item.title}}
                    </div>
                    <div class="text-line"></div>
                    <div class="meta clearfix">
                        <span v-show="item.sourceName">
                            {{item.sourceName}}
                        </span>
                        <span class="publishShowTime" v-show="item.publishShowTime">
                            {{item.publishShowTime}}
                        </span>
                        <span class="readNum" v-show="item.readNum">
                            <img src="./../assets/img/eyes.png" alt="">
                            {{item.readNum | resetNum}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="news-item holder" v-show="holder" v-for="i in holder" :key="'holder' + i*100"></div>
        </div>
        <div class="wap-newsList" v-if="isPhone" :class="columnId && `wap-newsList-${$Common.Base64.decode(columnId)}`">
            <a :href="toWapDetail(item)" target="_blank" class="news-item" :class="{'isSpecial': isSpecial}" v-for="(item, i) in list" :key="i">
                <div class="img bgc-default">
                    <img :src="item.img43 || item.topImgUrl || item.imgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt="">
                    <span v-show="item.newsKind == 4" class="video-icon"></span>
                    <span v-show="item.newsKind == 4" class="video-duration">{{item.videoTime | videoDuration}}</span>
                    <span v-show="item.isSubjectEntrance || item.extKind == 2" class="label" :class="{'label-activity': !item.isSubjectEntrance && item.extKind == 2,'isSpecial': isSpecial}">{{item | newsKind}}</span>
                    <span v-show="isSubjectList" class="label" :class="{'isSpecial': isSpecial}">专题</span>
                </div>
                <div v-if="!isActivity" class="text">
                    <div class="title line-3">{{item.title || item.name}}</div>
                    <div class="meta line-1" v-show="item.sourceName">{{item.sourceName}}</div>
                </div>
                <div v-else class="text">
                    <div class="title line-3">{{item.name}}</div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
// 新闻列表公用组件
export default {
    name: 'NewsList',
    data() {
        return {
            imgLoaded: `this.style.background = 'none'`,
            errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"'
        }
    },
    props: {
        column: { // 列数
            type: Number,
            default: 4
        },
        list: { //数据
            type: Array,
            default: []
        },
        type: { // 用于新闻详情页下一篇类型 1-信息流列表 2-专题列表 3-栏目列表
            type: Number,
            default: null
        },
        columnId: {
            type: String,
            default: null
        },
        subjectId: {
            type: String,
            default: null
        },
        skId: {
            type: String,
            default: null
        },
        channelId: {
            type: String,
            default: null
        },
        channelType: {
            type: String,
            default: null
        },
        isSubjectList: {
            type: Boolean,
            default: false
        },
        isActivity: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toDetail(item) {
            if(item.isSubjectEntrance) {
                window.open(this.$router.resolve({
                    path: `/subject/${this.$Common.Base64.encode(item.subjectId)}`,
                    query: this.dealQuery(),
                })['href'], '_blank');
            } else if(this.isSubjectList) {
                window.open(this.$router.resolve({
                    path: `/subject/${this.$Common.Base64.encode(item.id)}`,
                    query: this.dealQuery(),
                })['href'], '_blank');
            } else if(this.isActivity) {
                window.open(item.url)
            } else if(item.newsKind == 6) {
                window.open(item.externalUrl)
            } else {
                window.open(this.$router.resolve({
                    query: this.dealQuery(),
                    path: `/news/${this.$Common.Base64.encode(item.id)}`
                })['href'], '_blank');
            }
        },
        toWapDetail(item) {
            let url = '';
            if(item.isSubjectEntrance) {
                url = `/subject/${this.$Common.Base64.encode(item.subjectId)}`;
                if(this.columnId) url += '?columnId=' + this.columnId
            } else if(this.isSubjectList) {
                url = `/subject/${this.$Common.Base64.encode(item.id)}`;
                if(this.columnId) url += '?columnId=' + this.columnId
            } else if(this.isActivity) {
                url = item.url;
            } else if(item.newsKind == 6) {
                url = item.externalUrl;
            } else {
                url = `/news/${this.$Common.Base64.encode(item.id)}`;
            }
            return url;
        },
        dealQuery() {
            let obj = {};
            this.type && Object.assign(obj, {type: this.type});
            this.columnId && Object.assign(obj, {columnId: this.columnId});
            this.subjectId && Object.assign(obj, {subjectId: this.subjectId});
            this.skId && Object.assign(obj, {skId: this.skId});
            this.channelId && Object.assign(obj, {channelId: this.channelId});
            this.channelType && Object.assign(obj, {channelType: this.channelType});
            return obj;
        }
    },
    computed: {
        holder() {
            if(this.list && this.list.length) {
                let beNumber = this.column
                return this.list.length % beNumber == 0 ? 0 : beNumber - (this.list.length % beNumber)
            }
            return 0
        },
        isPhone() {
            return this.$Common.Attribute.isMb()
        }
    }
}
</script>
<style lang="less" scoped>
.newsList-wrapper {
    .pc-newsList {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        &.pc-newsList-208 {
            .news-item .text {
                .title{
                    font-size: 1rem;
                    line-height: 1.57rem;
                }
            }
        }
        .news-item {
            display: inline-block;
            width: 14.875rem;
            height: 15.125rem;
            background: #fff;
            margin-bottom: 1.5rem;
            box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.14);
            transition: all .5s;
            // &:hover {
            //     transform: scale(1.02);
            //     box-shadow: 0px 0px 10px 10px rgba(0, 0, 0, 0.14);
            // }
            &.isSpecial{
               box-shadow: 0px 0px 1px 1px #385C40;
            }
            &:hover .img img{
                transform: scale(1.05);
            }
            .img {
                height: 8.375rem;
                position: relative;
                overflow: hidden;
                .video-duration {
                    padding: 0.125rem 0.25rem;
                    color: #fff;
                    font-size: 0.6875rem;
                    position: absolute;
                    bottom: 0.5rem;
                    left: 0.6875rem;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 0.125rem;
                }
                .video-icon {
                    position: absolute;
                    width: 3.1875rem;
                    height: 3.1875rem;
                    background: url('./../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                img {
                    transition: all .5s;
                }
                .label{
                    &.isSpecial{
                        background: #385C40;
                    }
                }
            }
            .text {
                padding: 0.625rem 0.75rem;
                .title {
                    margin-bottom: 0.625rem;
                    font-size: 0.9375rem;
                    color: #333333;
                    font-weight: 600;
                    line-height: 1.5625rem;
                    height: 3.125rem;
                    overflow: hidden;
                }
                .meta {
                    padding-top: 0.625rem;
                    color: #999999;
                    font-size: 0.75rem;
                    line-height: 0.875rem;
                    span {
                        float: left;
                        max-width: 32%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin-left: 0.5em;
                        &:first-of-type {
                            margin-left: 0;
                        }
                    }
                    .readNum {
                        float: right;
                        margin-left: 0;
                        img {
                            width: 0.8125rem;
                            height: 0.5rem;
                        }
                    }
                    .publishShowTime {
                        max-width: 40%;
                    }
                }
            }
        }
        .subject-item {
            height: 12.875rem;
        }
        .holder {
            opacity: 0;
            height: 0;
        }
    }

    .wap-newsList {
        padding: 4.4vw 4vw 0;
        &.wap-newsList-208 {
            .news-item .text {
                .title {
                    font-size: 4.815vw;
                    line-height: 6.667vw;
                }
                .meta {
                    font-size: 3.241vw;
                }
            }
        }
        .news-item {
            width: 100%;
            padding-bottom: 4.267vw;
            border-bottom: 1px solid #EEEEEE;
            margin-bottom: 4.267vw;
            &.isSpecial{
                border-bottom: 1px solid #385C40;
            }
            .img {
               width: 32.533vw;
               height: 24.4vw;
               float: left;
               position: relative;
                .video-icon {
                    position: absolute;
                    width: 6.667vw;
                    height: 6.667vw;
                    background: url('./../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .video-duration {
                    padding: 0.267vw 0.533vw;
                    color: #fff;
                    font-size: 1.6vw;
                    position: absolute;
                    bottom: 3.998px;
                    left: 0.533vw;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 0.533vw;
                }
                .label {
                    padding: 2px 6px;
                    font-size: 3.2vw;
                    left: 1.6vw;
                    top: 1.6vw;
                    &.isSpecial{
                        background: #385C40;
                    }
                }
            }
            .text {
               margin-left: 36.667vw;
               height: 24.4vw;
               .title {
                   font-size: 4.533vw;
                   line-height: 6.4vw;
                   height: 19.2vw;
                   overflow: hidden;
                   color: #333333;
               }
               .meta {
                   color: #999999;
                   font-size: 3.2vw;
                //    line-height: 3.2vw;
                   margin-top: 1.067vw;
               }
            }
        }
    }
}
</style>